import moment from "moment"
import React, { Component } from "react"
import { Accordion, Card, OverlayTrigger, Popover, Tooltip } from "react-bootstrap"
import Select from "react-select"
import MsalAuth from "src/utilities/msalAuth"
import DatePicker from "../../../../../../components/common/DatePicker"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import ReferenceTypes from "../../../../Types/ReferenceTypes"
import UserSettings from 'src/utilities/UserSettings'
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import snackBar from "src/utilities/snackBar/SnackBar"

interface EmploymentStatusProps {
    employee: EmployeeDataTypes
    copy: EmployeeDataTypes
    reference: ReferenceTypes | any
    loading: boolean
    countMissing: Function
    handleChange: Function | any
    appendParams: Function
    setEventType: Function
    employeeBackround: any
    singleDetail?: string
    readOnly: boolean
}

class EmploymentStatus extends Component<EmploymentStatusProps, {}> {

    settings = MsalAuth.UserSettings() || { UserAdminEmploymentStatusOpen: true }

    updateUserSettings = () => {
        let settings = MsalAuth.UserSettings() || {}
        settings.UserAdminEmploymentStatusOpen = !this.settings.UserAdminEmploymentStatusOpen
        UserSettings.update(settings)
    }

    getTextFromReferenceData = (id: number | null) => {
        if (id) {
            const reasons: Array<any> = this.props.reference.terminationReasons
            for (let i = 0; i < reasons.length; i++) {
                if (id === reasons[i].TerminationReasonId) {
                    return reasons[i].TerminationReasonDesc
                }
            }
        }
        return "*NA*"
    }

    render() {

        let employee = this.props.employee
        let singleDetail = false
        if (this.props.singleDetail) {
            singleDetail = true
        }
        const readOnly = this.props.readOnly

        // const open = this.settings.UserAdminEmploymentStatusOpen

        const MissingEmpStatusInfoPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h2">Please check the following fields:</Popover.Title>
                {this.props.countMissing(["OriginalHireDate", "EmploymentStatus", "EmploymentStatusEffectiveDate", "PayType", "PayTypeEffectiveDate", "UnionCode", "UnionEffectiveDate"]).map((item: string, index: number) =>
                    <div className="uac-missing-info-tooltip-text" key={`miss-status-${index}`}>
                        <p className="uac-missing-info-tooltip-text-item-number">{`${index + 1}. `}</p>
                        <p className="uac-missing-info-tooltip-text-item">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
                    </div>
                )}
            </Popover>
        )

        const editEffectiveDateTooltip = (
            <Tooltip id="uac-tool-tip">
                Edit
            </Tooltip>
        )

        const EmploymentStatusEffectiveToolTip = (
            <Tooltip id="uac-tool-tip">
                Effective Date: {moment(employee.EmploymentStatusEffectiveDate).format("MMM Do YYYY") || "*NA*"}
            </Tooltip>
        )

        const UnionCodeEffectiveToolTip = (
            <Tooltip id="uac-tool-tip">
                Effective Date: {moment(employee.UnionEffectiveDate).format("MMM Do YYYY") || "*NA*"}
            </Tooltip>
        )


        const PayTypeEffectiveToolTip = (
            <Tooltip id="uac-tool-tip">
                Effective Date: {moment(employee.PayTypeEffectiveDate).format("MMM Do YYYY") || "*NA*"}
            </Tooltip>
        )

        // const effectiveDateTooltip = (key: string) => (
        //     <Tooltip id="uac-tool-tip">
        //         {/*@ts-ignore*/}
        //         Effective Date: {moment(employee[key]).format("MMM Do YYYY") || "*NA*"}
        //     </Tooltip>
        // )


        let termText = "*NA*"
        if (employee.hasOwnProperty("TerminationReasonId")) {
            termText = this.getTextFromReferenceData(employee.TerminationReasonId)
        }

        return (
            <div className="UserAdminR3">
                {/* <Accordion defaultActiveKey={open ? "0" : "1"} id="user-admin-accordion" */}
                <Accordion defaultActiveKey="0" id="user-admin-accordion"
                    onClick={() => this.updateUserSettings()}
                >
                    <Card id="user-admin-card">
                        <Accordion.Toggle as={Card.Header} eventKey="0" >
                            {this.props.loading && <div id="user-admin-card-title">
                                <p>Employment Status</p>
                            </div>}
                            {!this.props.loading && this.props.countMissing(["OriginalHireDate", "EmploymentStatus", "EmploymentStatusEffectiveDate", "PayType", "UnionCode", "UnionEffectiveDate"]).length === 0 && <div id="user-admin-card-title">
                                <p>Employment Status</p>
                            </div>}
                            {!this.props.loading && this.props.countMissing(["OriginalHireDate", "EmploymentStatus", "EmploymentStatusEffectiveDate", "PayType", "UnionCode", "UnionEffectiveDate"]).length > 0 && <div id="user-admin-card-title-warning">
                                <p>Employment Status</p>
                                <OverlayTrigger delay={{ show: 50, hide: 400 }} placement="right" overlay={MissingEmpStatusInfoPopover}>
                                    <div id="user-admin-card-title-warning-text">
                                        <span className="material-icons">warning</span>
                                        <p>({this.props.countMissing(["OriginalHireDate", "EmploymentStatus", "EmploymentStatusEffectiveDate", "PayType", "PayTypeEffectiveDate", "UnionCode", "UnionEffectiveDate"]).length})</p>
                                    </div>
                                </OverlayTrigger>
                            </div>}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <div id="uac-employment-status" style={{ boxShadow: this.props.employeeBackround.shadow }}>
                                <div id="uac-employment-status-r1">
                                    <div id="uac-employment-status-r1-c1">
                                        <div className="FindField" id="uac-employment-status-hire-date">
                                            <div id="uac-employment-status-hire-date-header">
                                                <div id="uac-employment-status-hire-date-header-left">
                                                    {employee.OriginalHireDate && <div id="uac-filled-field"><p>Original Hire Date{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                    {!employee.OriginalHireDate && <div id="uac-missing-field"><p>Original Hire Date<span className="material-icons">warning</span></p></div>}
                                                </div>
                                            </div>
                                            <DatePicker
                                                onChange={(date: any) => {
                                                    this.props.appendParams([{ OriginalHireDate: moment(date.valueOf()).format().split("T")[0] }])
                                                }}
                                                //@ts-ignore
                                                value={employee.OriginalHireDate || ""}
                                                useCloseCallback={true}
                                                disabled={singleDetail || readOnly}
                                            />
                                        </div>
                                    </div>
                                    <div id="uac-employment-status-r1-c2">
                                        <div className="FindField" id="uac-employment-status-term-date">
                                            <div id="uac-employment-status-term-date-header">
                                                <div id="uac-filled-field"><p>Termination Date</p></div>
                                            </div>
                                            <div className="UserAdminHasTrashCan">
                                                <DatePicker
                                                    onChange={(date: any) => {
                                                        this.props.appendParams([{ TerminationDate: moment(date.valueOf()).format().split("T")[0] }])
                                                    }}
                                                    //@ts-ignore
                                                    value={employee.TerminationDate || ""}
                                                    useCloseCallback={true}
                                                    disabled={singleDetail || readOnly}
                                                />
                                                {employee.TerminationDate && (!singleDetail && !readOnly && !this.props.loading) && <div className="UserAdminDateNuller">
                                                    <TrashCan color="#000000" clickCallback={() => this.props.appendParams([{ TerminationDate: null }, { TerminationReasonId: null }])} />
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div id="uac-employment-status-r1-c3">
                                        <div className="FindField" id="uac-employment-status-rehire-date">
                                            <div id="uac-employment-status-rehire-date-header">
                                                <div id="uac-filled-field"><p>Rehire Date</p></div>
                                            </div>
                                            <DatePicker
                                                onChange={(date: any) => {
                                                    this.props.appendParams([{ RehireDate: moment(date.valueOf()).format().split("T")[0] }])
                                                }}
                                                //@ts-ignore
                                                value={employee.RehireDate || ""}
                                                useCloseCallback={true}
                                                disabled={singleDetail || readOnly}
                                            />
                                        </div>
                                    </div>
                                    <div id="uac-employment-status-r1-c4">
                                        <div className="FindField" id="uac-employment-status-seniority-date">
                                            <div id="uac-employment-status-seniority-date-header">
                                                <div id="uac-filled-field"><p>Seniority Date</p></div>
                                            </div>
                                            <DatePicker
                                                onChange={(date: any) => {
                                                    this.props.appendParams([{ SeniorityDate: moment(date.valueOf()).format().split("T")[0] }])
                                                }}
                                                //@ts-ignore
                                                value={employee.SeniorityDate || ""}
                                                useCloseCallback={true}
                                                disabled={singleDetail || readOnly}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div id="uac-employment-status-r2">
                                    <div className="FindField" id="uac-employment-status-r2-c1">
                                        <div id="uac-employee-status-emp-status-header">
                                            <div id="uac-employee-status-emp-status-header-left">
                                                {employee.EmploymentStatus && <div id="uac-filled-field"><p>Employment Status{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                {!employee.EmploymentStatus && <div id="uac-missing-field"><p>Employment Status<span className="material-icons">warning</span></p></div>}
                                            </div>
                                            <div id="uac-employee-status-emp-status-header-right">
                                                <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={editEffectiveDateTooltip}>
                                                    <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("EmploymentStatusEffectiveDate")}>edit</span>}</div>
                                                </OverlayTrigger>
                                                {employee.EmploymentStatusEffectiveDate && <div id="uac-effective-date-available">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={EmploymentStatusEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                                {!employee.EmploymentStatusEffectiveDate && <div id="uac-effective-date-missing">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={EmploymentStatusEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                            </div>
                                        </div>
                                        {this.props.reference.employmentStatus && <Select
                                            id=""
                                            isDisabled={this.props.loading || singleDetail || readOnly}
                                            value={{ label: employee.EmploymentStatus || "*NA*" }}
                                            options={this.props.reference.employmentStatus.map((s: any) => ({ value: s.id, label: s.text }))}
                                            onChange={(item: any) => {
                                                if (item.label !== this.props.copy.EmploymentStatus) {
                                                    const d = moment().format().split("T")[0]
                                                    this.props.appendParams([
                                                        { EmploymentStatus: item.label },
                                                        { EmploymentStatusId: item.value },
                                                        { EmploymentStatusEffectiveDate: d },
                                                        { EmploymentStatusEffectiveDateId: null }
                                                    ])
                                                    snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                } else {
                                                    this.props.appendParams([
                                                        { EmploymentStatus: item.label },
                                                        { EmploymentStatusId: item.value },
                                                        { EmploymentStatusEffectiveDate: this.props.copy.EmploymentStatusEffectiveDate },
                                                        { EmploymentStatusEffectiveDateId: this.props.copy.EmploymentStatusEffectiveDateId }
                                                    ])
                                                }
                                            }}
                                            menuPlacement="top"
                                            maxMenuHeight={115}
                                        />}
                                    </div>
                                    <div className="FindField" id="uac-employment-status-r2-c2">
                                        <div id="uac-pay-type-emp-status-header">
                                            <div id="uac-pay-type-emp-status-header-left">
                                                {employee.PayType && <div id="uac-filled-field"><p>Pay Type{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                {!employee.PayType && <div id="uac-missing-field"><p>Pay Type<span className="material-icons">warning</span></p></div>}
                                            </div>
                                            <div id="uac-pay-type-emp-status-header-right">
                                                <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={editEffectiveDateTooltip}>
                                                    <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("PayTypeEffectiveDate")}>edit</span>}</div>
                                                </OverlayTrigger>
                                                {employee.PayTypeEffectiveDate && <div id="uac-effective-date-available">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={PayTypeEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                                {!employee.PayTypeEffectiveDate && <div id="uac-effective-date-missing">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={PayTypeEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                            </div>
                                        </div>
                                        {this.props.reference.payTypes && <Select
                                            id=""
                                            isDisabled={this.props.loading || singleDetail || readOnly}
                                            value={{ label: employee.PayType || "*NA*" }}
                                            options={this.props.reference.payTypes.map((s: any) => ({ value: s.id, label: s.text }))}
                                            onChange={(item: any) => {
                                                if (item.label !== this.props.copy.PayType) {
                                                    const d = moment().format().split("T")[0]
                                                    this.props.appendParams([
                                                        { PayType: item.label },
                                                        { PayTypeId: item.value },
                                                        { PayTypeEffectiveDate: d },
                                                        { PayTypeEffectiveDateId: null }
                                                    ])
                                                    snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                } else {
                                                    this.props.appendParams([
                                                        { PayType: item.label },
                                                        { PayTypeId: item.value },
                                                        { PayTypeEffectiveDate: this.props.copy.PayTypeEffectiveDate },
                                                        { PayTypeEffectiveDateId: this.props.copy.PayTypeEffectiveDateId }
                                                    ])
                                                }
                                            }}
                                            menuPlacement="top"
                                            maxMenuHeight={115}
                                        />}
                                    </div>
                                    <div className="FindField" id="uac-employment-status-r2-c3">
                                        <div id="uac-union-emp-status-header">
                                            <div id="uac-union-emp-status-header-left">
                                                {employee.UnionCode && <div id="uac-filled-field"><p>Union{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                                {!employee.UnionCode && <div id="uac-missing-field"><p>Union<span className="material-icons">warning</span></p></div>}
                                            </div>
                                            <div id="uac-union-emp-status-header-right">
                                                <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={editEffectiveDateTooltip}>
                                                    <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("UnionEffectiveDate")}>edit</span>}</div>
                                                </OverlayTrigger>
                                                {employee.UnionEffectiveDate && <div id="uac-effective-date-available">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={UnionCodeEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                                {!employee.UnionEffectiveDate && <div id="uac-effective-date-missing">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={UnionCodeEffectiveToolTip}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                            </div>
                                        </div>
                                        {this.props.reference.unionCodes && <Select
                                            id=""
                                            isDisabled={this.props.loading || singleDetail || readOnly}
                                            value={{ label: employee.UnionCode || "*NA*" }}
                                            options={this.props.reference.unionCodes.map((s: any) => ({ value: s.id, label: s.text }))}
                                            onChange={(item: any) => {
                                                if (item.label !== this.props.copy.UnionCode) {
                                                    const d = moment().format().split("T")[0]
                                                    this.props.appendParams([
                                                        { UnionCode: item.label },
                                                        { UnionCodeId: item.value },
                                                        { UnionEffectiveDate: d },
                                                        { UnionEffectiveDateId: null }
                                                    ])
                                                    snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                                } else {
                                                    this.props.appendParams([
                                                        { UnionCode: item.label },
                                                        { UnionCodeId: item.value },
                                                        { UnionEffectiveDate: this.props.copy.UnionEffectiveDate },
                                                        { UnionEffectiveDateId: this.props.copy.UnionEffectiveDateId }
                                                    ])
                                                }
                                            }}
                                            menuPlacement="top"
                                            maxMenuHeight={115}
                                        />}
                                    </div>

                                    <div className="FindField" id="uac-employment-status-r2-c4">
                                        <div id="uac-term-reason-emp-status-header">
                                            <div id="uac-term-reason-emp-status-header-left">
                                                <div id="uac-filled-field"><p>Reason for Separation</p></div>
                                            </div>
                                            {/* <div id="uac-term-reason-emp-status-header-right">
                                                {employee.TerminationReasonId && <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={editEffectiveDateTooltip}>
                                                    <div id="uac-effective-date-edit">{!readOnly && <span className="material-icons" onClick={() => this.props.setEventType("TerminationDate")}>edit</span>}</div>
                                                </OverlayTrigger>}
                                                {employee.TerminationReasonId && employee.TerminationDate && <div id="uac-effective-date-available">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={effectiveDateTooltip("TerminationDate")}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                                {employee.TerminationReasonId && !employee.TerminationDate && <div id="uac-effective-date-missing">
                                                    <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={effectiveDateTooltip("TerminationDate")}>
                                                        <span className="material-icons">event</span>
                                                    </OverlayTrigger>
                                                </div>}
                                            </div> */}
                                        </div>
                                        {this.props.reference.terminationReasons && <Select
                                            id=""
                                            isDisabled={this.props.loading || singleDetail || readOnly}
                                            value={{ label: termText }}
                                            options={this.props.reference.terminationReasons.map((s: any) => ({ value: s.TerminationReasonId, label: s.TerminationReasonDesc }))}
                                            onChange={(item: any) => {
                                                // if (item.value !== this.props.copy.TerminationReasonId) {
                                                //     this.props.appendParams([{ TerminationReasonId: item.value }, { TerminationDate: null }])
                                                // } else {
                                                //     this.props.appendParams([{ TerminationReasonId: item.value }, { TerminationDate: this.props.copy.TerminationDate }])
                                                // }
                                                const d = employee.TerminationDate ? employee.TerminationDate : moment().format().split("T")[0]
                                                this.props.appendParams([{ TerminationReasonId: item.value }, { TerminationDate: d }])
                                                snackBar({ text: `Effective: ${d}`, type: "plain", timeout: 3000 })
                                            }}
                                            menuPlacement="top"
                                            maxMenuHeight={115}
                                        />}
                                    </div>

                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

export default EmploymentStatus